import { z } from 'zod'

import {
  SLEEP_FREQUENCY_DAY,
  SLEEP_INDICATION
} from '@/modules/sleep/domain/models/SleepFrequency'

import { FlagModule } from './FlagModule'
import { ModuleFrequency } from './ModuleFrequency'

export const Flag = z.object({
  id: z.string(),
  enabled: z.boolean(),
  module: FlagModule,
  frequency: z
    .object({
      frequency: ModuleFrequency.optional(),
      sleepIndication: z.enum(SLEEP_INDICATION).optional(),
      observation: z.string().optional(),
      wakeUpObservations: z.string().optional(),
      sleepFrequency: z
        .array(
          z.object({
            id: z.string().nullable(),
            day: z.enum(SLEEP_FREQUENCY_DAY),
            initialTime: z.string(),
            endTime: z.string()
          })
        )
        .optional()
    })
    .optional()
})
export type Flag = z.infer<typeof Flag>
